import React from 'react';
import * as _ from 'lodash';
import {Button, Icon, Modal, message, Checkbox, Pagination} from 'antd';
import {WeaTools, WeaLocaleProvider, WeaUpload} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

class MaterialLibRight extends React.Component {
    state = {data: [], pageCurrent: 1, pageSize: 10, pageTotal: 0, checkedFiles: [], edit: false, file: {}};

    constructor(props) {
        super(props);
        this.onUploading = this.onUploading.bind(this);
        this.getFiles = this.getFiles.bind(this);
        this.onPageCurrentChange = this.onPageCurrentChange.bind(this);
        this.onPageSizeChange = this.onPageSizeChange.bind(this);
        this.onCheckAll = this.onCheckAll.bind(this);
        this.onCheck = this.onCheck.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.getCheckedFiles = this.getCheckedFiles.bind(this);
        this.imageCarousel = this.imageCarousel.bind(this);
    }

    componentWillMount() {
        this.getFiles(this.props.dir);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.dir != this.props.dir) {
            this.getFiles(nextProps.dir);
        }
    }

    componentDidUpdate() {
        const input = this.refs['input'];
        input && input.focus();
    }

    //图片放大轮播
    imageCarousel(imgObj,e){
        const {isShow} = this.props;
        if(!isShow) return;
        let imgPool = [];
        let indexNum = 0;
        jQuery(".portal-p4e-mlt-img").each(function(){
            const imgsrc = !!jQuery(this).attr("data-imgsrc") ? jQuery(this).attr("data-imgsrc") : jQuery(this).attr("src");
            imgPool.push(imgsrc);
        });
        let imgsrc = jQuery(e.target).attr("src");

        for(let i = 0; i < imgPool.length ; i ++){
            if(imgsrc == imgPool[i]){
                indexNum = i;
                break;
            }
        }
        window.IMCarousel.showImgScanner4Pool(true, imgPool, indexNum, null, window.top);
    }

    render() {
        const {hasRight, dir, multiCheck = false} = this.props;
        const {data = [], pageCurrent, pageSize, pageTotal, checkedFiles, edit, file} = this.state;
        const checkedCount = checkedFiles.length;
        const checkedAll = (checkedCount == data.length) && (data.length > 0);
        const disabled = checkedCount == 0;

        let row = [], col = [];
        for (let i = 0, len = data.length; i < len; i++) {
            col.push(data[i]);
            if (i % 5 == 4 || i == len - 1) {
                row.push(col);
                col = [];
            }
        }
        return (
            <div className="portal-p4e-mlr">
                {
                    hasRight ? (
                            <div className="portal-p4e-mlr-top">
                                {
                                    multiCheck && (
                                        <div className="portal-p4e-mlr-chk">
                                            <Checkbox checked={checkedAll} onChange={(e) => this.onCheckAll(e.target.checked)}>{getLabel(131965, '全选')}</Checkbox>
                                        </div>
                                    )
                                }
                                <div className="portal-p4e-mlr-btns">
                                    <WeaUpload
                                        uploadId="uploadFile"
                                        uploadUrl={`/api/portal/materialLib/uploadFile?dir=${dir}`}
                                        category="string"
                                        multiSelection={true}
                                        maxUploadSize={100}
                                        showClearAll={false}
                                        autoUpload={true}
                                        limitType="jpg,jpeg,gif,ico,bmp,png,flv,mp3,swf,mp4,wmv,ogg,webm"
                                        onUploading={this.onUploading}
                                        onChange={() => this.getFiles(dir)}
                                        style={{display: 'inline-block', paddingTop: 0}}
                                    >
                                        <Button type="primary" className="portal-p4e-mlr-btn">
                                            <Icon type="plus"/>
                                        </Button>
                                    </WeaUpload>
                                    <Button
                                        type="primary"
                                        disabled={disabled}
                                        className="portal-p4e-mlr-btn"
                                        style={disabled ? {backgroundColor: '#d8d8d8'} : {}}
                                        onClick={() => this.onBatchDelete()}
                                    >
                                        <Icon type="minus"/>
                                    </Button>
                                </div>
                            </div>
                        ) : ''
                }
                <div className="portal-p4e-mlr-middle">
                    {
                        row && row.length ? (
                                <div className="portal-p4e-mlt-table">
                                    {
                                        row.map((row, index) => {
                                            return (
                                                <ul key={index} className="portal-p4e-mlt-tr">
                                                    {
                                                        row.map((col) => {
                                                            const checked = _.findIndex(checkedFiles, (item) => item.id == col.id) != -1;
                                                            return (
                                                                <li key={col.id} className="portal-p4e-mlt-td">
                                                                    <div className="portal-p4e-mlt-item" style={checked ? {border: '1px solid #408de2'} : {}} >
                                                                        <div className="portal-p4e-mlt-chk" onClick={() => this.onCheck(col)}><Checkbox checked={checked}/></div>
                                                                        <div className="portal-p4e-mlt-preview">
                                                                            <img className="portal-p4e-mlt-img" src={`/weaver/weaver.splitepage.transform.SptmForThumbnail?filerealpath=${col.filepath.substring(1)}&time=${Date.now()}`} onClick={(e) => this.imageCarousel(this,e)} alt=""/>
                                                                        </div>
                                                                        {
                                                                            hasRight ? (
                                                                                    <div className="portal-p4e-mlt-opt">
                                                                                        <span className="portal-p4e-mlt-title">
                                                                                            {
                                                                                                col.id == file.id ? (
                                                                                                        edit ? (
                                                                                                                <input ref="input"
                                                                                                                       defaultValue={col.filename}
                                                                                                                       onClick={(e) => e.stopPropagation()}
                                                                                                                       onChange={this.onChange}
                                                                                                                       onKeyDown={(e) => {
                                                                                                                           e.stopPropagation();
                                                                                                                           if (e.keyCode == 13) {
                                                                                                                               this.onSave();
                                                                                                                           }
                                                                                                                       }}
                                                                                                                />
                                                                                                            ) : file.filename_new + '.' + col.filetype
                                                                                                    ) : col.filename + '.' + col.filetype
                                                                                            }
                                                                                        </span>
                                                                                        {
                                                                                            col.id == file.id && edit ? (
                                                                                                    <span className="portal-p4e-mlt-edit"
                                                                                                          onClick={(e) => {
                                                                                                              e.stopPropagation();
                                                                                                              this.onSave();
                                                                                                          }}
                                                                                                    >
                                                                                                        <i className="icon-coms-complete" title={getLabel(555, '完成')}/>
                                                                                                    </span>
                                                                                                ) : (
                                                                                                    <span className="portal-p4e-mlt-edit"
                                                                                                          onClick={(e) => {
                                                                                                              e.stopPropagation();
                                                                                                              this.onEdit(col)
                                                                                                          }}
                                                                                                    >
                                                                                                        <i className="icon-coms-edit" title={getLabel(26473, '编辑')}/>
                                                                                                    </span>
                                                                                                )
                                                                                        }
                                                                                        {
                                                                                            col.id == file.id && edit ? (
                                                                                                    <span className="portal-p4e-mlt-delete"
                                                                                                          onClick={(e) => {
                                                                                                              e.stopPropagation();
                                                                                                              this.onCancel();
                                                                                                          }}
                                                                                                    >
                                                                                                        <i className="icon-coms-Reset" title={getLabel(23757, '撤销')}/>
                                                                                                    </span>
                                                                                                ) : (
                                                                                                    <span className="portal-p4e-mlt-delete"
                                                                                                          onClick={(e) => {
                                                                                                              e.stopPropagation();
                                                                                                              this.onDelete(col.id)
                                                                                                          }}
                                                                                                    >
                                                                                                        <i className="icon-coms-delete" title={getLabel(91, '删除')}/>
                                                                                                    </span>
                                                                                                )
                                                                                        }
                                                                                    </div>
                                                                                ) : (
                                                                                    <div className="portal-p4e-mlt-opt">
                                                                                        <span className="portal-p4e-mlt-title2">{col.filename + '.' + col.filetype}</span>
                                                                                    </div>
                                                                                )
                                                                        }
                                                                    </div>
                                                                </li>
                                                            );
                                                        })
                                                    }
                                                </ul>
                                            );
                                        })
                                    }
                                    <div style={{clear: 'both'}}></div>
                                    <div style={{position: 'absolute', right: 0, margin: '10px'}}>
                                        <Pagination
                                            showSizeChanger
                                            showQuickJumper
                                            current={pageCurrent}
                                            pageSize={pageSize}
                                            total={pageTotal}
                                            showTotal={total => `${getLabel(18609, '共')} ${total} ${getLabel(18256, '条')}`}
                                            pageSizeOptions={['10', '20', '50', '100']}
                                            onChange={this.onPageCurrentChange}
                                            onShowSizeChange={this.onPageSizeChange}
                                        />
                                    </div>
                                </div>
                            ) : (
                                <div className="ant-table-placeholder">
                                    <i className="anticon anticon-frown"/>{getLabel(83553, '暂无数据')}
                                </div>
                            )
                    }
                </div>
            </div>
        );
    }

    onUploading(state) {
        if (state == 'uploading') {
            this.props.onLoading(true);
        } else if (state == 'uploaded') {
            this.props.onLoading(false);
        }
    }

    getFiles(dir, pageCurrent, pageSize) {
        this.props.onLoading(true);
        WeaTools.callApi('/api/portal/materialLib/getFiles', 'GET', {
            dir: dir || this.props.dir,
            pageCurrent: pageCurrent || this.state.pageCurrent,
            pageSize: pageSize || this.state.pageSize
        }).then(result => {
            this.setState({
                data: result.data,
                pageTotal: result.count,
                checkedFiles: [],
                edit: false,
                file: {}
            });
            this.props.onLoading(false);
        });
    }

    onPageCurrentChange(pageCurrent) {
        this.setState({pageCurrent: pageCurrent});

        const {dir} = this.props;
        const {pageSize} = this.state;
        this.getFiles(dir, pageCurrent, pageSize);
    }

    onPageSizeChange(current, pageSize) {
        this.setState({pageSize: pageSize});

        const {dir} = this.props;
        const {pageCurrent} = this.state;
        this.getFiles(dir, pageCurrent, pageSize);
    }

    onCheckAll(checked) {
        let {data = []} = this.state;
        let checkedFiles = [];
        if (checked) {
            data.forEach((item) => {
                checkedFiles.push(item);
            });
        }
        this.setState({checkedFiles: checkedFiles});
    }

    onCheck(file) {
        const {multiCheck = false} = this.props;
        let {checkedFiles} = this.state;

        if (_.findIndex(checkedFiles, (item) => item.id == file.id) != -1) {
            _.remove(checkedFiles, (item) => item.id == file.id);
        } else {
            if (multiCheck) {
                checkedFiles.push(file);
            } else {
                checkedFiles = [file];
            }
        }

        this.setState({checkedFiles: checkedFiles});
    }

    onEdit(file = {}) {
        this.setState({edit: true, file: {...file, filename_new: file.filename}});
    }

    onChange(e) {
        const {file} = this.state;
        this.setState({file: {...file, filename_new: e.target.value}});
    }

    onSave() {
        const {file} = this.state;
        const {filename_new = ''} = file;

        if (filename_new.trim() == '') {
            message.warning(getLabel(15859, '必要信息不完整！'));
        } else if (!filename_new.toLowerCase().match(/^[0-9A-Za-z]+$/)) {
            message.warning(getLabel(387216, '文件名称只能包含字母和数字'));
        } else {
            this.props.onLoading(true);
            this.setState({edit: false});
            WeaTools.callApi('/api/portal/materialLib/renameFile', 'POST', {
                ...file
            }).then(result => {
                if (result.api_status) {
                    message.success(getLabel(83885, '操作成功！'));
                    this.getFiles();
                } else {
                    message.warning(getLabel(83912, '操作失败！'));
                }
                this.props.onLoading(false);
            });
        }
    }

    onDelete(id) {
        Modal.confirm({
            title: getLabel(15172, '系统提示'),
            content: getLabel(15097, '确定要删除吗？'),
            onOk: () => {
                this.doDelete(id);
            }
        });
    }

    onBatchDelete() {
        const {checkedFiles = []} = this.state;
        const chkIds = checkedFiles.map((item) => {
            return item.id;
        });
        const ids = chkIds.join(',');

        Modal.confirm({
            title: getLabel(15172, '系统提示'),
            content: getLabel(385625, '确定要删除选择的记录吗？'),
            onOk: () => {
                this.doDelete(ids);
            }
        });
    }

    doDelete(ids) {
        this.props.onLoading(true);
        WeaTools.callApi('/api/portal/materialLib/deleteFile', 'POST', {ids}).then(result => {
            if (result.api_status) {
                message.success(getLabel(83885, '操作成功'));
                this.onPageCurrentChange(1);
            } else {
                message.warning(getLabel(83912, '操作失败'));
            }
            this.props.onLoading(false);
        });
    }

    onCancel() {
        this.setState({edit: false, file: {}});
    }

    getCheckedFiles() {
        return this.state.checkedFiles;
    }
}

export default MaterialLibRight;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-materiallib/MaterialLibRight.js